import script from "./renewOrder.vue?vue&type=script&setup=true&lang=js"
export * from "./renewOrder.vue?vue&type=script&setup=true&lang=js"

import "./renewOrder.vue?vue&type=style&index=0&id=7971cfad&lang=scss&scoped=true"

import exportComponent from "D:\\yunchi\\yc\\yc-vue-source\\new-energy\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7971cfad"]])

export default __exports__